<template>
    <div class="table-row" v-bind:class="{'table-row--header': header, 'table-row--footer': footer, 'table-row--vehicle': vehicle}">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'app-table-row',
        props: {
            header: {
                default: false
            },
            footer: {
                default: false
            },
            vehicle: {
                default: false
            }
        }
    }
</script>

<style lang="scss">
    .table-row {
        display: table-row;
        &:nth-child(even),
        &--header,
        &--footer {
            @apply .bg-grey-lightest;
        }
        &--header {
            font-weight: 500;
        }
        &.highlight {
            .table-cell {
                @apply .bg-grey-light;
            }
        }
        &--vehicle {
            background-color: #eaf1f7 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/table/Row.vue